import styled from "styled-components";

export const Styles = styled.div`
  height: 100%;
  .blank_space {
    height: 100%;
    border: 1px dashed #83b1e7;
  }

  .react-grid-item:not(.react-grid-placeholder) {
    background: #ccc;
    border: 1px solid #c2c2c2;
  }
  .item-container {
    &.radio_button,
    &.check_box {
      .item-box {
        &.fit-content {
          width: fit-content;
        }
        .options-container {
          &.is-horizontal {
            display: flex;
          }
        }
      }
    }
    padding: 0 5px;
    display: grid;
    flex-direction: column;
    grid-template-rows: auto 1fr;
    height: 100%;
    position: relative;
    &.border {
      display: flex;
      justify-content: center;
      padding: 0;
      .ant-divider {
        border-color: rgba(0, 0, 0, 0.5);
      }
    }
    &.vertical_border {
      display: block;
      > div {
        height: 100%;
      }
    }
    &.field_group {
      border: none !important;
      > .item-box {
        border: 1px dashed #d5d5d5 !important;
      }
    }
    .blank_space {
      height: 100%;
      border: 1px dashed #83b1e7;
    }
    .required-mark {
      color: #e74c3c;
      font-size: 20px;
    }
    .action-button {
      z-index: 99999;
      position: absolute;
      top: 0;
      right: 5px;
      cursor: pointer;
      .setting-button {
        color: red;
        font-size: 20px;
        &:hover {
          color: blue;
        }
      }
    }
    .item-box {
      height: 100%;
      overflow: auto;
      > .children-inner,
      .table-children_inner {
        display: block;
        height: 100%;
        .react-grid-layout {
          background-color: unset !important;
          z-index: 1;
        }
      }
      > * {
        background-color: #fafcff;
        border-color: #c9dfff;
        color: #83b1e7;
        .rdw-image-modal-btn,
        .rdw-link-modal-btn,
        .rdw-embedded-modal-btn {
          min-height: 42px;
          min-width: 96px;
        }
        .rdw-link-modal,
        .rdw-embedded-modal,
        .rdw-image-modal {
          min-width: 256px;
          min-height: 256px;
        }
        .rdw-editor-main {
          height: auto;
          max-height: 300px;
        }
      }
      .ant-picker-input input {
        color: #83b1e7;
      }
      .options-container {
        display: grid;
        grid-gap: 10px;
        &.is-horizontal {
          grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
        }
        .option {
          overflow: hidden;
          display: flex;
          flex-direction: row;
          align-items: center;
          padding: 10px;
          min-width: 105px;
        }
      }
      .attachment-container {
        padding: 10px;
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
      }
      .table-container {
        border: 1px dashed #d4d7d7;
        background-color: transparent;
        display: flex;
        padding: 0.1rem;
        .sortable-item {
          flex: 1;
        }
        .table-container--drop-section {
          display: flex;
          justify-content: center;
          align-items: center;
          text-align: center;
          width: 20%;
        }
        .sortable-item {
          display: grid;
          grid-auto-flow: column;
          grid-auto-columns: 1fr;
          > * {
            border: 1px solid black;
          }
        }
      }
    }
  }

  .not_allow_drop {
    background: #ccc !important;
    opacity: 0.9;
  }
`;
